import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { VerticalSeparator } from "../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import { FormTag } from "../../../tags/taggingSettings/components/formTag/formTag";
import styles from "../../proactiveMessagesList.css";
import { ExistingProactiveFormType } from "../../types";
import { FormCheckboxes } from "../formCheckboxes/formCheckboxes";
import { FormMessage } from "../formMessage/formMessage";

interface Props {
  form: ExistingProactiveFormType;
  isEdited: boolean;
}
export const ProactiveMsgBox = observer(({ form, isEdited }: Props) => {
  return (
    <div className={styles["form-content"]}>
      <div className={classNames(styles["input-container"], styles["tag-input"])}>
        <FormTag form={form.$.tag} isEdited={isEdited} />
      </div>
      <VerticalSeparator />
      <FormMessage field={form.$.message} isEdited={isEdited} />
      {!isEdited && (
        <>
          <VerticalSeparator />
          <FormCheckboxes form={form} />
        </>
      )}
    </div>
  );
});
